//--
$(document).ready(function () {

  $('#menuToggle').click(function() {
    $('#mobileMenu').addClass('active');
    $('#overlay').addClass('active');
});

$('#menuClose, #overlay').click(function() {
    $('#mobileMenu').removeClass('active');
    $('#overlay').removeClass('active');
});


  AOS.init({
    duration: 1000,
    delay: 100,
  });
});
//on scrll add class

$(window).scroll(function () {
  if ($(this).scrollTop() > 50) {
    $("header").addClass("header-bg");
  } else {
    $("header").removeClass("header-bg");
  }
});
//---
//---
///search bar dhow and hide
$(document).ready(function () {
  $("#search-bar-btn").click(function () {
    $("#header-search").slideToggle(1000);
  });
});

$(".shop-accessories-row").slick({
  rows: 3,
  dots: true,
  arrows: true,
  prevArrow:
    '<div class="nav-arrow arrow-left"><i class="fas fa-chevron-left"></i></div>',
  nextArrow:
    '<div class="nav-arrow arrow-right"><i class="fas fa-chevron-right"></i></div>',
  infinite: true,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 4,
  loop: true,
  responsive: [
    {
      breakpoint: 1025,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 4,
      },
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        rows: 2,
      },
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        rows: 2,
        dots: false,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        rows: 2,
        dots: false,
      },
    },
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ],
});
//--read more and read less

$(document).ready(function () {
  $("#toggle").click(function () {
    var elem = $("#toggle").text().trim();
    if (elem.includes("Read More")) {
      // Stuff to do when btn is in the read more state
      $("#toggle").html('Read Less <i class="fas fa-caret-up"></i>');
      $("#text").slideDown();
    } else {
      // Stuff to do when btn is in the read less state
      $("#toggle").html('Read More <i class="fas fa-caret-down"></i>');
      $("#text").slideUp();
    }
  });
});
//---product detail slider

$(".slider-for-1").slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  fade: true,
  asNavFor: ".slider-nav-1",
});
$(".slider-nav-1").slick({
  slidesToShow: 4,
  slidesToScroll: 4,
  asNavFor: ".slider-for-1",
  dots: true,
  arrows: false,
  centerMode: false,
  focusOnSelect: true,
});

$(document).ready(function () {
  $("#write-review-btn").click(function () {
    $("#right-review").slideDown("slow");
  });
});

$(document).ready(function () {
  $("#cancel-review").click(function () {
    $("#right-review").slideUp("slow");
  });
});

//main search-bad
$(document).ready(function () {
  $(".search-btn-1").on("click", function () {
    $(".search-bar-main-body").slideDown(1000);
  });
});

$(document).ready(function () {
  $(".search-btn-1-close").on("click", function () {
    $(".search-bar-main-body").slideUp(1000);
  });
});

//custome search bar
$(document).ready(function () {
  $(".custom-search-bar").each(function () {
    var $searchBar = $(this);

    $searchBar.find(".search-input").on("input", function () {
      var query = $(this).val().toLowerCase();
      if (query.length > 0) {
        $searchBar.find(".search-results").show();
        $searchBar.find(".close-btn").show();
      } else {
        $searchBar.find(".search-results").hide();
        $searchBar.find(".close-btn").hide();
      }
    });

    $searchBar.find(".close-btn").on("click", function () {
      $searchBar.find(".search-input").val("");
      $searchBar.find(".search-results").hide();
      $(this).hide();
    });

    $searchBar.find(".result-item").on("click", function () {
      $searchBar.find(".search-input").val($(this).text());
      $searchBar.find(".search-results").hide();
      $searchBar.find(".close-btn").hide();
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const popup = document.getElementById("membershipPopup");
  const openPopupBtn = document.querySelector(".becomeAMember");
  const closePopupBtn = document.querySelector(".close-popup");
  const addToCartBtn = document.getElementById("addToCartBtn");

  // Open the popup when "Become a Member" is clicked
  // openPopupBtn.addEventListener("click", function () {
  //   location.href = "/products/membership";
  //   // popup.style.display = "flex";
  // });

  // Close the popup when the close button is clicked
  closePopupBtn.addEventListener("click", function () {
    popup.style.display = "none";
  });

  // Close the popup if the user clicks outside the popup content
  popup.addEventListener("click", function (event) {
    if (event.target === popup) {
      popup.style.display = "none";
    }
  });

  // Add the product to the cart when the "Add to Cart" button is clicked
  addToCartBtn.addEventListener("click", function () {
    const variantId = this.getAttribute("data-product-id"); // Get the variant ID from the button's data attribute

    // Add product to cart via Shopify's AJAX API
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        quantity: 1, // Set the quantity to 1
        id: variantId, // Use the variant ID from the button's data attribute
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        popup.style.display = "none"; // Close the popup after adding to cart

        const cartButton = document.querySelector(
          ".header-cart-btn1.cart-toggle"
        );
        if (cartButton) {
          cartButton.click(); // Simulate the click event
        }
      })
      .catch((error) => console.error("Error adding to cart:", error));
  });
});

/// selector Wrapper////

// Function to handle both tasks: Adding membership_type class & setting the option
function updateMembershipTypeAndSelect() {
  // Wait 2 seconds to run this code
  setTimeout(function () {
    document.querySelectorAll(".selector-wrapper").forEach((wrapper) => {
      let label = wrapper.querySelector("label");
      let select = wrapper.querySelector("select"); // Get the select inside the wrapper

      console.log(
        "Label Found:",
        label ? label.textContent.trim() : "No Label"
      );

      if (label && select) {
        // Add membership_type class if label is "Type"
        if (label.textContent.trim() === "Type") {
          select.classList.add("membership_type"); // Add class to select if label is "Type"
          console.log("Added class 'membership_type' to:", select);

          // Set the value of the select based on is_member
          if (is_member === 1) {
            select.value = "Member"; // Select 'Member' option
          } else {
            select.value = "NonMember"; // Select 'NonMember' option
          }

          // Trigger the change event manually to call any event listeners
          let event = new Event("change");
          select.dispatchEvent(event); // This simulates the change event
          console.log(`Selected ${select.value} option.`);
        } else {
          wrapper.style.display = "block"; // Show all other selectors
          console.log("Set display:block for:", wrapper);
        }
      }
    });
  }, 2000); // 2 seconds delay
}

// Call the function to perform both actions
updateMembershipTypeAndSelect();

setTimeout(function () {
  // Find the section using its class name
  const section = document.querySelector(".shopify_subscriptions_app_block");

  if (section) {
    // Hide the section (set display to none)
    // section.style.display = "none";
  }

  // Find the Membership radio button using its class or a part of the ID
  const membershipRadio = document.querySelector(
    "input[type='radio'][id*='dedbef17312a8fbd04d63923ae037d2d97d1cf96']"
  );

  if (membershipRadio) {
    // Select the "Membership" radio button by default
    membershipRadio.checked = true;

    // Optionally, trigger the "change" event to simulate user interaction
    let event = new Event("change");
    membershipRadio.dispatchEvent(event);

    console.log("Membership radio button selected by default.");
  }
}, 2000); // Delay for 2 seconds before executing the code
setTimeout(() => {
  document.addEventListener("DOMContentLoaded", function () {
    const memberPrice = "{{ member_price }}";
    const memberVariantId = "{{ member_variant_id }}";

    document.addEventListener("change", function (event) {
      if (event.target.classList.contains("single-option-selector")) {
        // Get the selected variant's price dynamically
        let selectedVariant = window.meta.product.variants.find(
          (v) => v.id == document.querySelector("[name='id']").value
        );

        if (selectedVariant) {
          document.getElementById("productPrice").innerText =
            "AED " + Math.floor(selectedVariant.price / 100);

          // Ensure Member Price remains from "Type=Member" variant
          if (memberVariantId && selectedVariant.id != memberVariantId) {
            document.getElementById("memberPrice").innerText =
              "AED " + memberPrice;
          }
        }
      }
    });
  });
}, 2500);

function updateMembershipButton() {
  if (window.location.pathname.includes("products/membership")) {
    let button = document.querySelector(
      ".shopify-payment-button__button--unbranded"
    );
    if (button) {
      button.innerHTML = "Join Now";
    }
  }
}

// Run the function after the page loads
document.addEventListener("DOMContentLoaded", updateMembershipButton);


var popup = $('.welcome-website-popup-main');
  var over21Btn = $('.over-21');
  var under21Btn = $('.under-21');
  var path = window.location.pathname;
  var agePreference = localStorage.getItem('agePreference');
  if (agePreference === 'over21') {
    popup.removeClass('pop-visible');
    $('body').removeClass('scroll-hidden');
  } else if (agePreference === '') {
    popup.addClass('pop-visible');
    $('body').addClass('scroll-hidden');
  } else {
    popup.addClass('pop-visible');
    $('body').addClass('scroll-hidden');
  }
  over21Btn.on('click', function () {
    localStorage.setItem('agePreference', 'over21');
    popup.removeClass('pop-visible');
    $('body').removeClass('scroll-hidden');
    $('.show-error').removeClass('show');
  });
  under21Btn.on('click', function () {
    localStorage.setItem('agePreference', '');
    popup.addClass('pop-visible');
    $('body').addClass('scroll-hidden');
    $('.show-error').addClass('show');
  });
   